import { Dispatch, SetStateAction, useEffect } from 'react'

import { EvaluacionStepper, IEvaluacion } from '../constants';
import FormVideos from '../EvaluacionComponents/FormVideos'
import CantidadComidas from '../EvaluacionComponents/CantidadComidas'
import toast from 'react-hot-toast';


interface Props {
  setSection: Dispatch<SetStateAction<number>>;
  dataEvaluacion: IEvaluacion;
  handleChange(type: string, value: string | number): void;
}

const ComidasSection = ({setSection, dataEvaluacion, handleChange} : Props) => {

  useEffect(() => {
    const linkToTheTop = document.getElementById('GoToTheTop');
    linkToTheTop.click();
  }, [])

  const handleNext = () => {
    let err1 = false;
    if(dataEvaluacion.cantidadComidas === undefined || dataEvaluacion.cantidadComidas === 0 || dataEvaluacion.cantidadComidas === null){
      err1 = true;
    }

    if(err1){
      toast.error('Por favor selecciona una opción de días de prioridad');
      return;
    }

    if (!err1) {
      setSection((sec:number) => sec + 1);
    }
  }

  return (
    <>
      <FormVideos 
        url='https://player.vimeo.com/external/1047863156.m3u8?s=c3f7f781ca0983acea7390e18b3ccc60e8cd3a28&logging=false'
        evaluation
        noUnderlined
      />

      <CantidadComidas
        dataEvaluacion={dataEvaluacion}
        handleChange={handleChange}
      />
    </>
  )
}

export default ComidasSection